<section
	class="youtube-video-preview"
	[class.youtube-video-preview--modal]="isModalPreview"
>
	<!-- Header -->
	<header
		class="youtube-preview-header d-flex justify-content-between align-items-center"
		[class.card-header]="!isModalPreview"
		[class.modal-header]="isModalPreview"
		*ngIf="youtubeVideoData"
	>
		<!-- Hack for not focusing the modal button directly when modal loaded -->
		<input
			type="text"
			class="d-none"
			*ngIf="isModalPreview"
		/>

		<div class="youtube-preview-title">
			<span
				class="youtube-preview-eyebrow"
				*ngIf="isModalPreview"
			>
				Video tutorial
			</span>
			<h4>{{ youtubeVideoData.title }}</h4>
		</div>
		<ng-radio-button-group
			class="youtube-language-switcher"
			[buttonGroup]="videoLanguageOptions"
			variant="view-switcher"
			[(ngModel)]="selectedVideoLanguage"
			*ngIf="youtubeVideoData.videos && youtubeVideoData.videos.length > 0"
			(ngModelChange)="onLanguageSelect()"
		></ng-radio-button-group>
	</header>

	<!-- Content -->
	<div
		class="youtube-preview-body"
		[class.card-body]="!isModalPreview"
		[class.modal-body]="isModalPreview"
		*ngIf="youtubeVideoData.videos && youtubeVideoData.videos.length > 0"
	>
		<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
		<div
			class="ratio ratio-16x9 m-auto youtube-preview-frame"
			[style.max-width.px]="videoContainerWidth"
			*ngIf="videoUrl"
		>
			<iframe
				[src]="videoUrl | ngSafeURL"
				[attr.title]="youtubeVideoData.title + ' tutorial video'"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
				allowfullscreen
				loading="lazy"
			></iframe>
		</div>
	</div>

	<!-- Dynamic content -->
	<ng-content></ng-content>
</section>
